<template>
  <div id="login">
    <div class="login-img">
      <img src="@/assets/images/login.png" />
    </div>
    <div class="login-container">
      <h3 class="title">项目管理大数据指挥中心</h3>
      <el-form :model="loginForm" :rules="loginRule" ref="loginForm" class="content">
        <el-form-item prop="loginName">
          <el-input type="text" v-model.trim="loginForm.loginName"
           placeholder="请输入手机号" @keyup.enter.native="userLogin">
          </el-input>
        </el-form-item>
        <el-form-item prop="verificationCode">
          <div class="captcha">
            <el-input type="text" v-model.trim="loginForm.verificationCode"
              placeholder="请输入验证码"  @keyup.enter.native="userLogin">
            </el-input>
            <verify-code
              :mobile="loginForm.loginName"
              codeTemplate="login"
              style="flex: 1;">
            </verify-code>
          </div>
        </el-form-item>
        <el-button type="primary" class="login-btn"
          @click.native.prevent="userLogin" :loading="logining">
          登录
        </el-button>
        <div class="register">
          <router-link to="/bigdata/register">立即注册</router-link>
        </div>
      </el-form>
      <div>
      </div>
    </div>
  </div>
</template>

<script>

import VerifyCode from '@/components/VerifyCode.vue';

export default {
  components: {
    VerifyCode,
  },
  data() {
    return {
      logining: false,
      loginForm: {
        loginName: '',
        verificationCode: '',
      },
      loginRule: {
        loginName: [{
          required: true,
          pattern: /^1\d{10}$/,
          message: '手机号码不正确',
          trigger: 'blur',
        }],
        verificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 4, message: '验证码为4个字符', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    userLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.logining = true;
          this.$store.dispatch('doLogin', this.loginForm).then((result) => {
            this.logining = false;
            if (result.code === 0) {
              this.$router.push({ path: '/bigdata/home', redirect: { name: 'home' } });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/theme/app.scss';

  #login {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .login-container {
    padding-left: 8rem;
    padding-right: 8rem;
    padding-bottom: 8rem;
    width: 25rem;
    > .title {
      margin: 0px 0px 40px 0px;
      text-align: center;
      color: $login-title-color;
    }
    > .content {
      background: $login-background-color;
      border: 1px solid $login-border-color;
      box-shadow: 0px 0px 5px $login-border-show-color;
      padding: 2rem 2rem 0rem 2rem;
    }
    .captcha {
      display: flex;
      align-items: center;
    }
    /deep/ .el-input__inner {
      background-color: $login-background-color;
      color: $white-color;
      border-color: $login-input-border-color;
    }
    .register {
      text-align: right;
      line-height: 2rem;
      height: 2rem;
      /deep/ a, .el-link.el-link--default {
        font-size: 0.7rem;
        color: $login-register-color;
        text-decoration: none;
        &:hover {
          color: $font-color-focus;
        }
      }
    }
  }

  .login-btn {
    background-color: $login-button-color;
    color: $login-button-text-color;
    width: 100%;
    height: 40px;
    border: none;
    font-size: 1rem;
    font-weight:bold;
    &:hover,
    &:focus {
      background: $login-button-active-color;
      border-color: $login-register-color;
      color: $hover-backgroud-color;
    }
    &:active {
      background: $login-button-active-color;
      color: $hover-backgroud-color;
      outline: none;
    }
  }
</style>
